import { ColumnDescription } from "react-bootstrap-table-next";
import {
    ListarProdutosInteresseVendasController,
    ProdutoVendasController,
} from "../../../Controllers/Vendas/Produtos/ProdutosController";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import Table from "../../Table";
import { useState } from "react";
// import { IComponentModal } from "../../Modais/IModalComponent";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { IListaProdutosInteresseRequest } from "../../../Interfaces/Vendas/Produtos/ProdutosInterfaces";
// import ModalComponent from "../../Modais";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { useAtendimentoPage } from "../../../Context/AtendimentoPage";
import { Spinner } from "../../Loding/SpinnerPadrao";

export default function ProdutoInteresse() {
    // const [show, setShow] = useState(false);
    // const [modal, setModal] = useState<IComponentModal>();

    const { ID_CASO, Atendimento } = useAtendimentoPage();

    const [selectedIdProdutoInteresse, setSelectedIdProdutoInteresse] =
        useState<Array<number>>([]);

    const {
        value: lstProdutosInteresse,
        loading: lstProdutosInteresseLoading,
        execute: ListarProdutosInteresseVendas,
    } = useAsyncEffect(async () => {
        const res = await ListarProdutosInteresseVendasController(ID_CASO);
        setSelectedIdProdutoInteresse(
            res
                ?.filter((produtos) => produtos.FL_PRODUTO_INTERESSE)
                .map((lst) => lst.ID_PRODUTO)
        );
        return res;
    }, [ID_CASO]);

    const { execute: ProdutoVendas, loading: ProdutoVendasLoading } =
        useAsyncCallback(ProdutoVendasController);

    const columns: Array<ColumnDescription<IListaProdutosInteresseRequest>> = [
        {
            dataField: "DS_PRODUTO_COMP",
            text: "Produto",
            align: "center",
            headerAlign: "center",
        },
        // {
        //     dataField: "",
        //     text: "Visualizar",
        //     align: "center",
        //     headerAlign: "center",
        //     formatter: (c, row) => (
        //         <button
        //             className="btn btn-primary"
        //             onClick={() => {
        //                 setShow(true);
        //                 setModal({
        //                     headerComponent: "Imagem do Produto",
        //                     IconHeader: faEye,
        //                     Component: () => (
        //                         <div>
        //                             <h6>{row.DS_PRODUTO_COMP}</h6>
        //                             <img
        //                                 src={row.DS_IMG_EMPREENDIMENTO}
        //                                 alt="Imagem do Produto"
        //                             />
        //                         </div>
        //                     ),
        //                     size: "xl",
        //                 });
        //             }}
        //         >
        //             Visualizar
        //         </button>
        //     ),
        // },
    ];

    return (
        <>
            <div className="card card-custom ">
                <div className="d-flex flex-column p-8 y-scroll">
                    <div className="d-flex justify-content-between align-items-center py-2">
                        <h4>Produto Interesse</h4>
                        <button
                            className="btn btn-clean btn-success btn-icon"
                            disabled={
                                selectedIdProdutoInteresse?.length === 0 ||
                                !selectedIdProdutoInteresse ||
                                ProdutoVendasLoading
                            }
                            onClick={() => {
                                ProdutoVendas({
                                    ID_PRODUTO: selectedIdProdutoInteresse ?? 0,
                                    ID_OPORTUNIDADE:
                                        Atendimento?.ID_OPORTUNIDADE ?? 0,
                                }).then(() => {
                                    ListarProdutosInteresseVendas();
                                });
                            }}
                        >
                            {ProdutoVendasLoading ? (
                                <Spinner size="sm" />
                            ) : (
                                <FontAwesomeIcon icon={faSave} size="lg" />
                            )}{" "}
                        </button>
                    </div>
                    <Table
                        columns={columns}
                        data={lstProdutosInteresse ?? []}
                        keyField="ID_PRODUTO"
                        loading={lstProdutosInteresseLoading}
                        noSearch
                        striped
                        rowStyle={{ cursor: "pointer" }}
                        bordered={false}
                        selectRow={{
                            mode: "checkbox",
                            clickToSelect: true,
                            selected: selectedIdProdutoInteresse.map(
                                (id) => id
                            ),

                            onSelect: (row, isSelect) => {
                                if (isSelect) {
                                    setSelectedIdProdutoInteresse((id) => [
                                        ...id,
                                        row.ID_PRODUTO,
                                    ]);
                                } else {
                                    setSelectedIdProdutoInteresse((lstId) =>
                                        lstId.filter(
                                            (id) => id !== row.ID_PRODUTO
                                        )
                                    );
                                }
                            },
                            onSelectAll: (isSelect, rows) => {
                                if (isSelect) {
                                    setSelectedIdProdutoInteresse((produto) => [
                                        ...produto,
                                        ...rows.map(
                                            (produtos) => produtos.ID_PRODUTO
                                        ),
                                    ]);
                                } else {
                                    setSelectedIdProdutoInteresse([]);
                                }
                            },
                        }}
                    />
                </div>
            </div>
            {/* <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            /> */}
        </>
    );
}
